var _rect, _rect2, _rect3, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 88,
    fill: "#F0F3F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3977,
    transform: "translate(-686 -2209)",
    fill: "#F5F6F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -610.5,
    y: -649.5,
    width: 1310,
    height: 1158,
    rx: 19.5,
    fill: "white",
    stroke: "#A7AABD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_827_40342)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 40,
    r: 40,
    fill: "#2B5297"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 40,
    r: 39.5,
    stroke: "#2B5297"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 15C41.9621 15 39.8972 17.0649 39.8972 19.6029V22.7409C39.8972 25.2789 41.9621 27.3438 44.5 27.3438C47.038 27.3438 49.1028 25.2789 49.1028 22.7409V19.6029C49.1028 17.0649 47.038 15 44.5 15V15Z",
    fill: "#E9E9E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8971 35.3965H61.7592C59.2212 35.3965 57.1562 37.4613 57.1562 39.9993C57.1562 42.5373 59.2212 44.6021 61.7592 44.6021H64.8971C67.4351 44.6021 69.5 42.5373 69.5 39.9993C69.5 37.4613 67.4351 35.3965 64.8971 35.3965Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8437 39.9993C31.8437 37.4613 29.7788 35.3965 27.2408 35.3965H24.1029C21.5649 35.3965 19.5 37.4613 19.5 39.9993C19.5 42.5373 21.5649 44.6021 24.1029 44.6021H27.2409C29.7789 44.6021 31.8437 42.5373 31.8437 39.9993Z",
    fill: "#C3C3C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9587 31.0503L62.1776 28.8315C63.9722 27.0369 63.9723 24.1167 62.1776 22.322C60.3828 20.5274 57.4627 20.5274 55.6681 22.322L53.4493 24.5409C51.6547 26.3355 51.6546 29.2557 53.4493 31.0503C55.2439 32.8449 58.164 32.8449 59.9587 31.0503Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0409 48.9495L26.8221 51.1683C25.0275 52.9629 25.0274 55.8831 26.8221 57.6778C28.6167 59.4724 31.5369 59.4724 33.3315 57.6778L35.5504 55.4589C37.345 53.6643 37.3451 50.7441 35.5504 48.9495C33.7557 47.1549 30.8356 47.1549 29.0409 48.9495Z",
    fill: "#C3C3C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9587 48.9495C58.1641 47.1549 55.2439 47.1548 53.4492 48.9495C51.6546 50.7441 51.6546 53.6643 53.4492 55.459L55.6681 57.6778C57.4627 59.4724 60.3829 59.4725 62.1775 57.6778C63.9721 55.8832 63.9721 52.963 62.1775 51.1684L59.9587 48.9495Z",
    fill: "#E9E9E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3315 22.3221C31.5369 20.5275 28.6167 20.5274 26.822 22.3221C25.0274 24.1168 25.0274 27.0369 26.822 28.8315L29.0409 31.0504C30.8355 32.845 33.7557 32.8451 35.5503 31.0504C37.3449 29.2557 37.3449 26.3355 35.5503 24.5409L33.3315 22.3221Z",
    fill: "#E9E9E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 27.3437C47.038 27.3437 49.1028 25.2788 49.1028 22.7408V19.6029C49.1028 17.0649 47.038 15 44.5 15V27.3437Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 52.6548C41.9621 52.6548 39.8972 54.7197 39.8972 57.2577V60.3957C39.8972 62.9336 41.9621 64.9985 44.5 64.9985C47.038 64.9985 49.1028 62.9336 49.1028 60.3956V57.2576C49.1028 54.7196 47.038 52.6548 44.5 52.6548Z",
    fill: "#C3C3C3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 64.9986C47.038 64.9986 49.1028 62.9337 49.1028 60.3957V57.2577C49.1028 54.7197 47.038 52.6548 44.5 52.6548V64.9986Z",
    fill: "#E9E9E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -14374,
    y: -24273,
    width: 53660,
    height: 41487,
    stroke: "black",
    strokeWidth: 50
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_827_40342",
    x: 0.5,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.321569 0 0 0 0 0.592157 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_827_40342"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_827_40342",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderReview);
export default __webpack_public_path__ + "static/media/under-review.d2bf0f11494b7d7a5a2d12da760fd080.svg";
export { ForwardRef as ReactComponent };